<!--
 * @Author: yezi
 * @Date: 2020-05-26 11:45:04
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 15:01:40
 * @Description:
-->
<template>
 <div class="content">
    <div class="cItem">
      <div style="display:flex;align-items: center;" @click="back">
        <van-icon name="arrow-left" size="22px" style="margin-right:0.1rem"/>
        <P>{{title}}</P>
      </div>
      <video :src="sources" controls="controls" controlslist="nodownload" playsinline :poster="video_page" />
    </div>
 </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data () {
    return {
      sources: '',
      title: '',
      video_page: ''
    }
  },
  created () {
    this.sources = this.$route.query.sources
    this.title = this.$route.query.title
    this.video_page = this.$route.query.video_page
  },
  methods: {
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.content {
  padding-bottom: 0.5rem;
  margin: 0 0.2rem;
}
.tItem {
  margin-top: 0.59rem;
  width: 100%;
  padding: 0.4rem;
  border-radius: 0.16rem;
  box-shadow: 0rem 0rem 0.46rem 0rem rgba(4,0,0,0.13);
}
.tItem  p{
  font-size: 0.4rem;
  font-weight: bold;
  color: #121212;
}
.listTitle {
  position: fixed;
  bottom: 37%;
  left: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 4000;
}
.listTitle label {
  width:1.37rem;
  height:0.73rem;
  background:rgba(250,170,34,1);
  border-radius:0.16rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.seriesList {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 0.2rem;
  padding: 0.3rem 0;
  overflow-x: scroll;
}
.seriesItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.cItem {
  margin-top: 0.59rem;
}
.cItem p {
  color: #121212;
  font-size: 0.34rem;
  font-weight: bold;
}
.cItem video {
  margin-top: 0.3rem;
  width: 7.1rem;
  background-color: #121212;
}
.videoJust {
  width: 7.1rem;
  height:7.1rem
}
.videoWide {
  width: 7.1rem;
  height: 4rem;
}
</style>
